export class FailedRecaptchaError extends Error {
  constructor() {
    super('The reCaptcha attempt failed. Please reload the page and try again.')
    Object.setPrototypeOf(this, FailedRecaptchaError.prototype)
  }
}
